// extracted by mini-css-extract-plugin
export default {"-large":"RSCX78ccwEAjDjCURuDH","container":"plFrJoMc1rJfoy0RGVcH","small":"xR2GUIqJGMSo7nTH_7VB","medium":"zhAc1QSrEgtW5tMd1ewS"};